import { render } from "./ContentEditablePe.vue?vue&type=template&id=275557f4"
import script from "./ContentEditablePe.vue?vue&type=script&lang=js"
export * from "./ContentEditablePe.vue?vue&type=script&lang=js"

import "./ContentEditablePe.vue?vue&type=style&index=0&id=275557f4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__